'use strict';

import DataTransport from "@/helpers/data-transport";
import AlertMessage from "@/helpers/alert-message";

(function() {
    const transport = new DataTransport();
    const alertMessage = new AlertMessage();
    const priceBlockContents = document.querySelector('[data-role="price-block-contents"]');
    const priceBlockForm = document.querySelector('[data-role="price-block-form"]');

    RefreshPriceBlocks();


    priceBlockForm.addEventListener("submit", async function(e) {
        e.preventDefault();

        const formData = new FormData(this);

        const actionUrl = this.action || this.getAttribute('action');

        await transport.PostFormData(`${actionUrl}`, formData)
            .then(async data => {
                console.log(data);
                if (!data.error) {
                    RefreshPriceBlocks();
                }
            })
            .catch(error => console.error('Failed to fetch data:', error))
            .finally(() => {

            });
    });


    async function RefreshPriceBlocks() {
        const url = new URL(window.location.href);
        const pageId = url.searchParams.get('pageId');
        await transport.GetRawResponse(`/admincp/ShowGamePage/?exec=getPriceBlocks&pageId=${pageId}`, {})
            .then(data => {
                priceBlockContents.innerHTML = data;

                // Add event listeners to "remove" buttons
                const removeButtons = priceBlockContents.querySelectorAll('[data-role="remove-price"]');
                removeButtons.forEach(button => {
                    button.addEventListener("click", async (e) => {
                        e.preventDefault();

                        const priceBlockId = button.getAttribute("data-price-block-id");
                        if (!priceBlockId) return;

                        await transport.GetRawResponse(`/admincp/UpdateGamePage/?exec=removePriceBlock&priceBlockId=${priceBlockId}`, {
                            priceBlockId: priceBlockId
                        }).then(response => {
                            if (!response.error) {
                                RefreshPriceBlocks(); // Refresh after successful removal
                            } else {
                                console.log(response);
                            }
                        })
                        .catch(error => console.error('Failed to fetch data:', error))
                        .finally(() => {

                        });
                    });
                });

                // Add event listeners to "popular" radio buttons
                const popularRadios = priceBlockContents.querySelectorAll('[data-role="price-popular"]');
                popularRadios.forEach(radio => {
                    radio.addEventListener("change", async (e) => {
                        const selectedId = radio.getAttribute("data-price-block-id");

                        if (!selectedId) return;

                        await transport.PostFormData(`/admincp/UpdateGamePage/?exec=setPopularPriceBlock&priceBlockId=${selectedId}`, {})
                            .then(response => {
                                console.log(response);
                                if (!response.error) {
                                    RefreshPriceBlocks(); // Refresh to reflect change
                                } else {
                                    alertMessage.Error(response.message || "Failed to set popular price block.");
                                }
                            })
                            .catch(error => console.error('Failed to update popular price block:', error));
                    });
                });
            })
            .catch(error => console.error('Failed to fetch data:', error))
            .finally(() => {

            });
    }
})();